import api from 'services/inventory/maintenance-schedule'

export const handleSave = async (values: any) => {
  let res = await api.updateAction(values)

  return res?.data?.success
}
